import React, { useState } from 'react';
import "./menu.css"

interface MenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const Menu: React.FC<MenuProps> = ({ isOpen, onClose }) => {
  return (
    <div className={`menu ${isOpen ? 'open' : ''}  font-anek-devanagari`}>
      <div className="nigga">
        <button className="closeButton" onClick={onClose}>
          Close
        </button>
        
      </div>
      <a href="https://docs.google.com/forms/d/e/1FAIpQLSevB1lrMkluH4mn9mIReaQBsp_Q0s5MWpr9jIjnZAkhgAuvMw/viewform" className='no-underline'>
        <div className='lin no-underline'>
  Apply
        </div>
      </a>
      <a href="#aboutUs" className='no-underline'>
        <div className='lin no-underline'>
      About Us
        </div>
      </a>
      <a href="#team" className='no-underline'>
        <div className='lin'>
        Our Team
        </div>
      </a>
      <a href="/" className='no-underline'>
        <div className='lin'>
    PFP Gallery
        </div>
      </a>
      
      
    </div>
  );
};

export default Menu;